import { render, staticRenderFns } from "./ClassMemberCard.vue?vue&type=template&id=1fd5d811&scoped=true"
import script from "./ClassMemberCard.vue?vue&type=script&lang=js"
export * from "./ClassMemberCard.vue?vue&type=script&lang=js"
import style0 from "./ClassMemberCard.vue?vue&type=style&index=0&id=1fd5d811&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd5d811",
  null
  
)

export default component.exports